import React, {useState} from 'react';
import {theme} from '../../styles/darkTheme';
import {
  Container,
  HeaderContainer,
  PageName,
  BackButton,
  Title,
  TitleContainer,
  CardsContainer,
  Button,
} from './styles';
import {useTranslation} from '../../context/language';
import Card from '../../components/atoms/Card';
import store from '../../redux/store';
import LoadingSpinner from '../../components/atoms/LoadingSpinner';
import axios from '../../utils/axios';
import {useDispatch, useSelector} from 'react-redux';
import {SET_REMITTANCE_RESPONSE} from '../../redux/actionTypes';
import {useNavigate} from 'react-router-dom';
import {RemittanceResponseState} from '../../redux/reducers/remittanceResponse';
import {Attachment, Channel} from 'stream-chat';
import {selectOrCreateChat, sendMessage} from '../../redux/actions/channel';
import {RootState} from '../../redux/reducers';
import {setAlert} from '../../redux/actions/global';
import {getErrorMessage} from '../../utils/getters';
import {
  EmailIcon,
  EmailShareButton,
  TelegramIcon,
  TelegramShareButton,
  WhatsappIcon,
  WhatsappShareButton
} from 'react-share';
import Alert from '../../components/atoms/Alert';

const ConfirmRemittance = () => {
  const {title, text} = useTranslation();
  const {remittance, user} = store.getState();
  const {description, amount, senderFullName,  codeRemittance} = remittance;
  const {dialCountryCode : countryCode, mobileNumber: mobilePhone } = remittance.senderPhone
  const [showInvite, setShowInvite] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const history = useNavigate();
  const {currentWatchChannel, id} = useSelector((state: RootState) => ({
    ...state.channel,
    ...state.user,
  }));

  const getUserData = () => {
    const members = currentWatchChannel?.members;
    if (!members) return;
    for (let i = 0; i < members?.length || 0; i++) {
      const curr = members[i];
      if (curr.user_id !== id) {
        return curr.user;
      }
    }
    return null;
  };
  const currentUser = getUserData();

  const moneyFrom = 'DOP';
  const moneyTo = 'USD';

  const handleClick = async () => {
    try {
      const urlValidate = '/api/v1/user/widget/validate/user/'
      const validate = await axios.post(urlValidate, {
        dialCountryCode: `+${countryCode}`,
        mobileNumber: mobilePhone
      });
      if (!validate.data.valid) {
        setShowInvite(true)
      } else {
        await callbackInvite()
      }

    } catch (e: any) {
      setLoading(false);
      console.log(e);
      dispatch(
        setAlert({
          title: e.name,
          message: getErrorMessage(400, text),
          callback: () => history('/welcome'),
        }),
      );
    }
  };

  const callbackInvite = async () => {
    const data = {
      senderFullName: senderFullName,
      senderPhone: {
        dialCountryCode: `+${String(countryCode)}`,
        mobileNumber: mobilePhone,
      },
      recipientPhone: {
        dialCountryCode: user.dialCountryCode,
        mobileNumber: user.mobileNumber,
      },
      amount: amount,
      description: description,
      codeRemittance: codeRemittance,
    };
    const data2 = {
      phoneNumber: {
        dialCountryCode: `+${String(countryCode)}`,
        mobileNumber: mobilePhone,
      },
      fullName: senderFullName,
    };
    const url = 'api/v1/remittance/widget/request/';
    const url2 = '/api/v1/user/widget/init_chat/';
    setLoading(true);
    const res = await axios.post(url, data);
    //console.log('responsesese: ', res.data)
    const res2 = await axios.post(url2, data2);
    setLoading(false);
    if (res.data) {
      const {
        id,
        action,
        timeTransaction,
        createdAt,
        updatedAt,
        sender,
        recipient,
        beneficiary,
        extraInfo,
        purposedTransactions
      } = res.data;
      const resData: RemittanceResponseState = {
        id,
        action,
        timeTransaction,
        createdAt,
        updatedAt,
        sender,
        recipient,
        beneficiary,
        extraInfo,
        purposedTransactions
      };

      const attachments: Attachment[] = [
        {
          type: 'request_remittance',
          amount: `${extraInfo.receiving.amount} ${extraInfo.receiving.currency}`,
          id,
          convertedAmount: `${200} ${'DOP'}`,
          rate: `1${moneyFrom} = ${extraInfo.exchangeRate}${moneyTo}`,
          concept: description,
          createdAt,
        },
      ];
      dispatch({type: SET_REMITTANCE_RESPONSE, payload: resData});
      createChat({userID: res2.data.id}, () => sendNewMessage(attachments));
      history('/details');
    }
  }

  const sendNewMessage = (attachments: Attachment[]) => {
    const {currentChannel: currCh, currentWatchChannel} =
      store.getState().channel;
    dispatch(sendMessage(currCh as Channel, '', attachments));
    history('/details');
  };

  const createChat = (
    {userID}: {userID: string},
    callback: () => any,
  ): void => {
    if (userID) {
      dispatch(selectOrCreateChat({members: [userID, id], callback: callback}));
    }
  };

  return (
    <>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <Container theme={theme}>
          <HeaderContainer>
            <PageName theme={theme}>{title.confirmRemittance}</PageName>
            <BackButton theme={theme} onClick={() => history(-1)}>
              {text.goBack}
            </BackButton>
          </HeaderContainer>
          <TitleContainer>
            <Title>{text.confirmRemittance}</Title>
          </TitleContainer>
          <Alert
              isVisible={showInvite}
              callback={async () => await callbackInvite() }
              setIsVisible={setShowInvite}
              title={text.invite}
              message={text.inviteMessage(`${countryCode}${mobilePhone}`)}
          >
            <>
              <WhatsappShareButton
                  url={text.inviteMessageOut}
                  style={{marginRight: 5}}>
                <WhatsappIcon size={32} round />
              </WhatsappShareButton>
              <TelegramShareButton
                  url={text.inviteMessageOut}
                  style={{marginRight: 5}}>
                <TelegramIcon size={32} round />
              </TelegramShareButton>
              <EmailShareButton
                  url={text.inviteMessageOut}
                  style={{marginRight: 5}}>
                <EmailIcon size={32} round />
              </EmailShareButton>
            </>
          </Alert>
          <CardsContainer>
            <Card
              label={text.amountRemittance}
              value={`${parseFloat(amount || '').toFixed(2)} ${String(moneyFrom)}`}
              valueColor={theme.background}/>
            <Card
              label={text.requesterRemittance}
              value={senderFullName}
              valueSize={'32px'}
              valueColor={theme.background}
            />
            <Card
              value={`🇺🇸 +${String(countryCode)} ${String(mobilePhone)}`}
              valueSize={'24px'}
              valueColor={theme.background}
            />
            <Card
              label={text.noteRemittance}
              value={description}
              valueSize={'24px'}
              valueColor={theme.background}
              clear
            />
            <Button onClick={handleClick}>
              {text.confirmButtonRemittance}
            </Button>
          </CardsContainer>
        </Container>
      )}
    </>
  );
};

export default ConfirmRemittance;
